import { useEffect, useState } from 'react'
import {
  configureChains,
  createClient,
  useAccount,
  useNetwork,
  useProvider,
  useSigner,
} from 'wagmi'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'
import { EthereumClient, modalConnectors } from '@web3modal/ethereum'
import { gnosisChiado, gnosisMainnet, goerliEther } from '../helpers/chains'

const chains = [gnosisMainnet, gnosisChiado, goerliEther]

// Wagmi client
const { provider } = configureChains(chains, [
  jsonRpcProvider({
    rpc: (chain) => {
      return {
        http: chain.rpcUrls.default.http[0],
      }
    },
  }),
])
export const wagmiClient = createClient({
  autoConnect: true,
  connectors: modalConnectors({ appName: 'Launchpad', chains }),
  provider,
})

// Web3Modal Ethereum Client
export const ethereumClient = new EthereumClient(wagmiClient, chains)

export const useWallet = () => {
  const { data: signer } = useSigner()
  const [wallet, setWallet] = useState({
    address: '',
    chainId: 0,
    provider: null,
    signer,
  })
  const web3provider = useProvider()
  const { address } = useAccount()
  const { chain } = useNetwork()

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    chain
      ? setWallet({
          address,
          chainId: chain.id,
          provider: web3provider,
          signer,
        })
      : null
  }, [address])

  return { wallet, address, chain }
}
